var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHubLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8564_4904)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 8,
    fill: "url(#paint0_linear_8564_4904)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "url(#paint1_linear_8564_4904)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "url(#paint2_linear_8564_4904)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8518 16.6363C19.8518 18.1575 18.9511 19.5344 17.5572 20.1438L8.09399 24.2812L8.09399 21.4262C8.09399 19.9049 8.99474 18.5281 10.3886 17.9187L17.554 14.7859C18.6379 14.312 19.8518 15.1062 19.8518 16.2891L19.8518 16.6363Z",
    fill: "url(#paint3_linear_8564_4904)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.09375 11.309C8.09375 9.78776 8.9945 8.41087 10.3883 7.80147L19.8516 3.66406V6.51912C19.8516 8.04036 18.9508 9.41725 17.557 10.0267L10.3916 13.1594C9.3077 13.6333 8.09375 12.8392 8.09375 11.6562V11.309Z",
    fill: "url(#paint4_linear_8564_4904)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8517 15.6406C19.8517 14.3104 18.9777 13.1383 17.7027 12.7587L13.9728 11.6484L10.9103 10.6914C10.9103 10.6914 9.19401 10.1701 9.16031 9.29687C9.14661 8.94217 9.4064 8.42187 9.4064 8.42187C9.4064 8.42187 8.80484 8.91406 8.44937 9.67968C8.0939 10.4453 8.0939 11.2109 8.0939 11.2109V11.9657C8.0939 13.6593 9.20669 15.1516 10.8299 15.6347L13.9728 16.5703L16.5431 17.3359C16.5431 17.3359 19.1242 17.949 18.8126 19.0039C18.7477 19.2238 18.5392 19.5234 18.5392 19.5234C18.5392 19.5234 19.0587 19.0946 19.4416 18.375C19.9487 17.4217 19.8517 15.6406 19.8517 15.6406Z",
    fill: "url(#paint5_linear_8564_4904)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8564_4904",
    x1: 5.55078,
    y1: -0.875,
    x2: 13.4531,
    y2: 16.1055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#341BFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E013BE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8564_4904",
    x1: 9.48828,
    y1: 14,
    x2: 11.2109,
    y2: 21.6289,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F72E40",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F72E40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8564_4904",
    x1: 4.62109,
    y1: 28,
    x2: 12.8516,
    y2: 14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDD620"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDD620",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_8564_4904",
    x1: 8.09399,
    y1: 24.2812,
    x2: 19.8518,
    y2: 16.0234,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4879F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_8564_4904",
    x1: 10.3906,
    y1: 11.0195,
    x2: 19.8516,
    y2: 3.66406,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEFBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7A2FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_8564_4904",
    x1: 8.0939,
    y1: 10.2812,
    x2: 19.8517,
    y2: 14.6016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB4CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8564_4904"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 8,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHubLogo);
export default __webpack_public_path__ + "static/media/hub-logo.9dabf25ce24e36a495e734d3da6d1c7d.svg";
export { ForwardRef as ReactComponent };